import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WIDGET } from '../../../../shared/interfaces/widget';
import { DataService } from '../../../../services/dashboard/data.service';

@Component({
  selector: 'app-add-widgets',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './add-widgets.component.html',
  styleUrl: './add-widgets.component.css'
})
export class AddWidgetsComponent implements OnInit {

  @Output() addWidgetsModalOpen = new EventEmitter<boolean>();

  widgets:WIDGET[] = [];
  selectedWidgets: any[] = [];
  stagedWidgets: { id: number; onDashboard: boolean }[] = [];

  @Output() widgetsUpdated = new EventEmitter<WIDGET[]>();



constructor(private ds:DataService){}

  ngOnInit(): void {
    this.widgets=this.ds.defaultWidgetsInDashboard;
  }

  closeModal() {
    this.addWidgetsModalOpen.emit(false);
  }

  toggleWidget(widget: any) {
    const exists = this.selectedWidgets.find(w => w.id === widget.id);
  
    if (exists) {
      this.selectedWidgets = this.selectedWidgets.filter(w => w.id !== widget.id);
      this.stagedWidgets = this.stagedWidgets.filter(w => w.id !== widget.id);
      this.stagedWidgets.push({ id: widget.id, onDashboard: false });
    } else {
      this.selectedWidgets.push(widget);
      this.stagedWidgets = this.stagedWidgets.filter(w => w.id !== widget.id);
      this.stagedWidgets.push({ id: widget.id, onDashboard: true });
    }
  }
  

  isSelected(widget: any): boolean {
    return this.selectedWidgets.some(w => w.id === widget.id);
  }

  addWidgetsToDashboard() {
    this.stagedWidgets.forEach(staged => {
      const target = this.widgets.find(w => w.id === staged.id);
      if (target) {
        target.onDashboard = staged.onDashboard;
      }
    });
  this.widgetsUpdated.emit(this.widgets);
   this.addWidgetsModalOpen.emit(false);
   this.ds.defaultWidgetsInDashboard=this.widgets;
  }
  
}
